import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=284c695a&"
import script from "./nav-header.vue?vue&type=script&lang=js&"
export * from "./nav-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports